import { CLEAR, SET_MEDIA } from '../actions/Playback';
;
const initialState = {
    onNext: undefined,
    onPrevious: undefined,
    onRepeatAll: undefined,
    onRepeatOff: undefined,
    onRepeatOne: undefined,
    onShuffleOff: undefined,
    onShuffleOn: undefined,
    onThumbsDown: undefined,
    onThumbsUp: undefined,
    onUndoThumbsDown: undefined,
    onUndoThumbsUp: undefined,
    onVolumeChange: undefined,
};
const reducer = {
    [CLEAR]: () => initialState,
    [SET_MEDIA]: (state, action) => {
        if (action.payload.actions) {
            return Object.assign(Object.assign({}, state), action.payload.actions);
        }
        else {
            return state;
        }
    },
};
export function PlaybackActionsReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    else {
        return state;
    }
}
